<div
  ts-page-title
  class="d-flex flex-column"
  [navigation_title]="navigation_title"
  [page_title]="page_title"
>
  @if (!order_not_found) {
    <div class="container-md mt-2 p-md-0">
      @if (order_summary) {
        <ts-order-details
          [order_id]="order_summary.id"
          [related_order_info]="order_summary.related_order_info"
          [related_order_url]="order_summary.related_order_url"
          [order_type_id]="order_summary.store_order_type_id"
          [price_summary]="order_summary.order_price_summary"
          [source_order_details]="order_summary.source_order"
          [order_tracker]="order_summary.order_tracker"
          [asset_details]="asset_details"
          [additional_info]="order_summary.store_order_additional_info"
          [order_status_desc]="order_status_desc"
          [is_tmo_environment]="is_tmo_environment"
          [is_summary_page]="true"
          [carrier_order_number]="order_summary.carrier_order_number"
        />
      }
    </div>
  }
</div>
